module.exports = __webpack_public_path__ + "a99c79fd0e15c53e8f9df75d0ccc4294.png";